import { buildPublicAppUrl } from '../config/hostApps';

export const STUDENT_TOKEN_QUERY_PARAM = 's';
export const ONBOARDING_PROJECT_QUERY_PARAM = 'p';
export const CINTA_NATURAL_ONBOARDING_PROJECT = 'cinta-natural';

export const appendStudentTokenToPath = (path: string, token?: string | null): string => {
  const normalizedToken = token?.trim();

  if (!normalizedToken) {
    return path;
  }

  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}${STUDENT_TOKEN_QUERY_PARAM}=${encodeURIComponent(normalizedToken)}`;
};

const buildStudentTokenSearch = (token: string): string => (
  `${STUDENT_TOKEN_QUERY_PARAM}=${encodeURIComponent(token.trim())}`
);

export const isCintaNaturalOnboardingSearch = (searchParams: URLSearchParams): boolean => (
  searchParams.get(ONBOARDING_PROJECT_QUERY_PARAM)?.trim() === CINTA_NATURAL_ONBOARDING_PROJECT
);

const buildCintaNaturalOnboardingSearch = (token: string): string => {
  const search = new URLSearchParams();
  search.set(ONBOARDING_PROJECT_QUERY_PARAM, CINTA_NATURAL_ONBOARDING_PROJECT);
  search.set(STUDENT_TOKEN_QUERY_PARAM, token.trim());
  return search.toString();
};

/**
 * Links públicos compartilháveis. Toda a decisão de origin/path
 * (subdomínio oficial em produção × rota interna em dev/vercel.app)
 * está centralizada em `buildPublicAppUrl` (src/config/hostApps.ts).
 */
export const buildOnboardingUrl = (token: string): string => (
  buildPublicAppUrl('onboarding', { search: buildStudentTokenSearch(token) })
);

export const buildCintaNaturalUrl = (token: string): string => (
  buildPublicAppUrl('onboarding', { search: buildCintaNaturalOnboardingSearch(token) })
);

export const buildAnamneseUrl = (token: string): string => (
  buildPublicAppUrl('anamnese', { search: buildStudentTokenSearch(token) })
);

export const buildEnviarFotosUrl = (token: string): string => (
  buildPublicAppUrl('enviar-fotos', { search: buildStudentTokenSearch(token) })
);

export const buildEquipamentosUrl = (token: string): string => (
  buildPublicAppUrl('equipamentos', { search: buildStudentTokenSearch(token) })
);

export const buildParqUrl = (token: string): string => (
  buildPublicAppUrl('parq', { search: buildStudentTokenSearch(token) })
);

export const buildQueroComecarUrl = (): string => (
  buildPublicAppUrl('quero-comecar')
);

export const buildFupPublicUrl = (token: string, studentNameSlug?: string | null): string => (
  buildPublicAppUrl('fup', {
    pathSuffix: `/${encodeURIComponent(token.trim())}${studentNameSlug?.trim()
      ? `/${encodeURIComponent(studentNameSlug.trim())}`
      : ''}`,
  })
);
